import { useGetUser } from '../users/use-get-user';
export function useIntacctCompanyId(options) {
    return useGetUser(undefined, options).data?.company.intacctCompanyId;
}
//# sourceMappingURL=use-intacct-company-id.js.map